import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const DrillDownTable = ({ data, type }) => {
  if (!data?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No data
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ maxHeight: '65vh' }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow
            sx={{
              "& th": {
                fontWeight: 600,
                backgroundColor: "neutral.light",
              },
            }}
          >
            <TableCell width={20}>#</TableCell>
            <TableCell>
              {type === "flight" ? "Flight" : "User"}
            </TableCell>
            <TableCell align="right">Logs</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data?.map((row, idx) => (
            <TableRow key={row.id} hover>
              <TableCell>{idx + 1}</TableCell>

              <TableCell>
                <Typography variant="body2" fontWeight={500}>
                  {row.label}
                </Typography>
              </TableCell>

              <TableCell align="right">
                <Typography variant="body2">
                  {row.count}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DrillDownTable;
